var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addressBar"},[_c('p',{staticClass:"PL fl"},[_c('a',{attrs:{"href":""}},[_vm._v(_vm._s(_vm.addressBarData.PColumn ? _vm.addressBarData.PColumn.Name : _vm.addressBarData.lanmu.Name)+"\n        ")])]),_vm._v(" "),_c('p',{staticClass:"PR fr"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bb9217a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/addressBar.vue
// module id = null
// module chunks = 